// extracted by mini-css-extract-plugin
export default {"container":"styles_container__psb8Q","replyIcon":"styles_replyIcon__n3XPp","button":"styles_button__M-olg","createAt":"styles_createAt__l-0vY","content":"styles_content__yG0MY"};